module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard 2\n  </title>\n  <path d=\"M18 8v2l-2 .545V16c-3.8-3.025-6.294-3.871-9.461-4.318-1.335-.171-1.758.162-1.261 1.994.731 2.691 1.097.05 1.832 2.202L3.841 17 2.13 11.178C.866 11.06 0 11 0 11V6.773s3.372-.234 6.539-.682C9.706 5.644 12.2 5.025 16 2v5.455L18 8z\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-18-news.svg
// module id = 3702
// module chunks = 168707334958949